import React from 'react';
import styled from 'styled-components';
import Bgdoctor from "../../Image/Bgdoctor.png";
import Harry from '../../Image/Harry.png';
import Carls from '../../Image/Carlos.png';
import Austin from '../../Image/Austin.png';
import Meg from '../../Image/Meg.png';

const Doctorinfo = () => {
    const Doctorinformation = [
        {
            doctorname: 'Harry McGuier',
            specialict: 'Leading Densit',
            des: 'Meg is a leading dentist in our central hospital. She has made the name in California Silicon Valley when presenting the new technology, today called “anti-cancer”.',
            certificate: '32',
            happyclients: '1200+'
        },
        {
            doctorname: 'Carlos Forbidden',
            specialict: 'Leading Densit',
            des: 'Meg is a leading dentist in our central hospital. She has made the name in California Silicon Valley when presenting the new technology, today called “anti-cancer”.',
            certificate: '32',
            happyclients: '1200+'
        },
        {
            doctorname: 'Austin Arment',
            specialict: 'Leading Densit',
            des: 'Meg is a leading dentist in our central hospital. She has made the name in California Silicon Valley when presenting the new technology, today called “anti-cancer”.',
            certificate: '32',
            happyclients: '1200+'
        },
        {
            doctorname: 'Meg Styles',
            specialict: 'Leading Densit',
            des: 'Meg is a leading dentist in our central hospital. She has made the name in California Silicon Valley when presenting the new technology, today called “anti-cancer”.',
            certificate: '32',
            happyclients: '1200+'
        },
    ];

    return (
        <Doctormain>
            <BgDoctorImg src={Bgdoctor} alt="Doctor Background" />

            {Doctorinformation.map((doctor, index) => (
                <DoctorCard key={index}>
                    <DoctorImage src={index === 0 ? Harry : index === 1 ? Carls : index === 2 ? Austin : Meg} alt={doctor.doctorname} />
                    <Certificate>
                        <CertificateResult>{doctor.certificate}</CertificateResult>
                        <CertificateHeading>Certificates</CertificateHeading>
                        <CertificateResult>{doctor.happyclients}</CertificateResult>
                        <CertificateHeading>Happy Clients</CertificateHeading>
                    </Certificate>
                    <DoctorDetails>
                        <DoctorName>{doctor.doctorname}</DoctorName>
                        <Specialist>{doctor.specialict}</Specialist>
                        <DoctorDescription>{doctor.des}</DoctorDescription>
                    </DoctorDetails>
                </DoctorCard>
            ))}
        </Doctormain>
    );
};

export default Doctorinfo;

const Doctormain = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(247, 252, 253, 1);

`;

const BgDoctorImg = styled.img`
    width: 100%;
    max-width: 100%;
    height: auto;
`;

const DoctorCard = styled.div`
    margin: 20px; 
    display: flex;
    gap:20px;
    justify-content: space-around;
    align-items: center;
    color: rgba(255, 255, 255, 0.8);
    border-radius: 30px;
    padding: 20px;
    width: 80%;
    max-width: 800px;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
    }
`;

const DoctorImage = styled.img`
    width: 372px;
    height: 372px;
    border-radius: 30px;
`;

const Certificate = styled.div`
    width: 200px;
    height: 372px;
    border-radius: 30px;
    background: rgba(229, 102, 30, 0.05);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const CertificateHeading = styled.div`
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    line-height: 23px;
    text-align: left;
    color: rgba(6, 33, 38, 0.7);
    // color: white;
    padding: 10px;
    border-radius: 30px 30px 0 0;
`;

const CertificateResult = styled.div`
    font-family: Poppins;
    font-size: 24px;
    font-weight: 600;
    line-height: 27px;
    text-align: left;
    color: rgba(207, 125, 78, 1);
    padding: 20px;
    border-radius: 0 0 30px 30px;
`;

const DoctorDetails = styled.div`
    text-align: left;
    width: 50%;
    max-width: 400px;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const DoctorName = styled.div`
    font-family: Poppins;
    font-size: 24px;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;
    color: black;
    // background: rgba(207, 125, 78, 1);
    padding: 10px;
    border-radius: 30px 30px 0 0;
`;

const Specialist = styled.div`
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    padding: 10px;
    color: rgba(207, 125, 78, 1);
`;

const DoctorDescription = styled.div`
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
    color: rgba(6, 33, 38, 0.7);
    padding: 20px;
    border-radius: 0 0 30px 30px;
`;
